import { MODELTYPE_LIST, MODELTYPE_LIST_SUCCESS, MODELTYPE_LIST_ERROR, ADD_MODELTYPE, ADD_MODELTYPE_SUCCESS, ADD_MODELTYPE_ERROR, EDIT_MODELTYPE, EDIT_MODELTYPE_SUCCESS, EDIT_MODELTYPE_ERROR, MODELTYPE_DETAILS, MODELTYPE_DETAILS_SUCCESS, MODELTYPE_DETAILS_ERROR, DELETE_MODELTYPE, DELETE_MODELTYPE_SUCCESS, DELETE_MODELTYPE_ERROR } from './constants';


export default function ModelTypeDataReducer(state, action) {
    
	let data = [];
	// let questions = [];

	switch (action.type) {

	case MODELTYPE_LIST:
		return { ...state, loading : true, error : false};

	case MODELTYPE_LIST_SUCCESS:
		if(action?.payload.data){
			action?.payload?.data?.map((item) => {
				data.push({
					id : item && item?.id ? item.id : null,
					name : item && item?.name ? item.name : '',
					dimension : item && item?.dimension ? item.dimension : 'Nill',
					position : item && item?.position ? item.position : 'Nill'
				});
			});
		}

		return {...state, modeltype : data,  loading : false, error : false};

	case MODELTYPE_LIST_ERROR:
		return { ...state, modeltype : [], loading : false, error : true};

	case ADD_MODELTYPE:
		return { ...state, loading: true };
	case ADD_MODELTYPE_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_MODELTYPE_ERROR:
		return {...state, loading : false, error : true};

	case EDIT_MODELTYPE:
		return { ...state, loading: true, error: false };

	case EDIT_MODELTYPE_SUCCESS:
		return { ...state,  loading: false, error : false };

	case EDIT_MODELTYPE_ERROR:
		return {...state, loading : false, error : true};

	case MODELTYPE_DETAILS:
		return { ...state, loading: true };

	case MODELTYPE_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };

	case MODELTYPE_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_MODELTYPE:
		return { ...state, loading: false };

	case DELETE_MODELTYPE_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_MODELTYPE_ERROR:
		return { ...state, loading: false, error: true };

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}